import { render, staticRenderFns } from "./DashedList.vue?vue&type=template&id=853874ce&scoped=true&"
import script from "./DashedList.vue?vue&type=script&lang=js&"
export * from "./DashedList.vue?vue&type=script&lang=js&"
import style0 from "./DashedList.vue?vue&type=style&index=0&id=853874ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853874ce",
  null
  
)

export default component.exports